import { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import { openPublishDialog, unPublishRequest } from 'reactApp/modules/modifying/modifying.actions';
import { IOpenPublishDialog, IUnPublishRequest } from 'reactApp/modules/modifying/modifying.types';
import { store } from 'reactApp/store';

export const publishHelper = (params: IOpenPublishDialog) => store.dispatch(openPublishDialog({ ...params, from: EFrom.WEBLINK }));

export const unPublishHelper = (params: IUnPublishRequest) => store.dispatch(unPublishRequest(params));
